// // import monitor from "./picture/monitor.png"
// import monitor from "./picture/稿定设计-5.png"
// import background from "./picture/稿定设计-6.png"
// import {Component} from "react";
//
// class Monitor extends Component {
//     render() {
//         const backImg = {
//             backgroundImage:`url(${background})`,
//             backgroundSize:"100% 100%",
//             // height:'10vh',
//             // scrollMarginTop:"140px",
//             display:"flex",
//             marginTop:window.innerWidth*0.184,
//             // fontSize:'50px',
//         }
//         return (
//             <>
//                 <div id="monitor_introduce" style={backImg}>
//                     <div style={{height: "26%", marginLeft:"24%", marginTop:"0px"}}>
//                         <b style={{fontSize:window.innerWidth*0.052, opacity:"0.1", marginTop:window.innerWidth*0.09}}>非接触式</b>
//                         <p style={{fontSize:window.innerWidth*0.036, fontWeight:"bold", marginTop:"0px", marginBottom:"30px"}}>动态心率呼吸监测仪</p>
//                         <b style={{backgroundColor:"RoyalBlue  ", color:"white", fontSize:window.innerWidth*0.021, marginTop:"0px", paddingLeft:"20px",
//                           paddingRight:"20px"}}>- 您枕下的无扰健康管家 -</b>
//                         <div style={{display:"flex"}}>
//                             <div>
//                                 <p style={{fontSize:window.innerWidth*0.016, marginBottom:"10px"}}>精准睡眠监测</p>
//                                 <p style={{fontSize:window.innerWidth*0.016, marginTop:"10px"}}>心率变异监测</p>
//                             </div>
//                             <div style={{marginLeft:"30px"}}>
//                                 <p style={{fontSize:window.innerWidth*0.016, marginBottom:"10px"}}>呼吸暂停监测</p>
//                                 <p style={{fontSize:window.innerWidth*0.016, marginTop:"10px"}}>慢性病程管理</p>
//                             </div>
//                         </div>
//                     </div>
//                     {/*position:"absolute", right:"0px", bottom:"142px"*/}
//                     <div style={{ marginRight:"15%"}}>
//                         <img style={{height:window.innerWidth*0.35, width:window.innerWidth*0.55, marginLeft:"22%" }} src={monitor} alt=""/>
//                         {/*style={{height:"50", width:"50"}}*/}
//                     </div>
//
//                 </div>
//
//             </>
//         )
//     }
//
// }
//
//
// export default Monitor;
//
//
//


// import monitor from "./picture/monitor.png"
import monitor from "./picture/稿定设计-5.png"
import background from "./picture/稿定设计-6.png"
import {Component} from "react";

class Monitor extends Component {
  render() {
    const backImg = {
      backgroundImage:`url(${background})`,
      backgroundSize:"100% 100%",
      // height:'10vh',
      // scrollMarginTop:"140px",
      display:"flex",
      marginTop:window.innerWidth*0.0894,
      // fontSize:'50px',
    }
    return (
      <>
        <div id="monitor_introduce" style={backImg}>
          <div style={{height: "26%", marginLeft:"10%", marginTop:window.innerWidth*0.15}}>
            <b style={{fontSize:window.innerWidth*0.052, opacity:"0.1"}}>非接触式</b>
            <p style={{fontSize:window.innerWidth*0.036, fontWeight:"bold", marginTop:"0px", marginBottom:"3px"}}>动态心率呼吸监测仪</p>
            <b style={{backgroundColor:"RoyalBlue  ", color:"white", fontSize:window.innerWidth*0.021, marginTop:"0px", paddingLeft:"20px", paddingRight:"20px"}}>- 您枕下的无扰健康管家 -</b>
            <div style={{display:"flex"}}>
              <div>
                <p style={{fontSize:window.innerWidth*0.016, marginBottom:"5%"}}>精准睡眠监测</p>
                <p style={{fontSize:window.innerWidth*0.016, marginTop:"5%"}}>心率变异监测</p>
              </div>
              <div style={{marginLeft:"8%"}}>
                <p style={{fontSize:window.innerWidth*0.016, marginBottom:"5%"}}>呼吸暂停监测</p>
                <p style={{fontSize:window.innerWidth*0.016, marginTop:"5%"}}>慢性病程管理</p>
              </div>

            </div>

          </div>
          <div style={{ marginRight:"-15%", marginTop:window.innerWidth*0.1}}>
            <img style={{height:window.innerWidth*0.35, width:window.innerWidth*0.5 }} src={monitor} alt=""/>
          </div>

        </div>

      </>
    )
  }

}


export default Monitor;



